import React, { PropTypes } from 'react';
import cn from 'classnames';
import { childrenShape } from '@bibliocommons/bc-prop-types';

import './BatchActionLink.scss';

export default function BatchActionLink({ className, disabled, href, children, handleClick }) {
  if (disabled) {
    return (
      <span className={cn('cp-batch-action-link', 'btn disabled', className)}>
        {children}
      </span>
    );
  }

  return (
    <a className={cn('cp-batch-action-link', className)} href={href} onClick={handleClick}>
      {children}
    </a>
  );
}

BatchActionLink.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  children: childrenShape,
  handleClick: PropTypes.func
};



// WEBPACK FOOTER //
// ./app/components/shared/BatchActions/BatchActionLink/BatchActionLink.jsx